import { ChangeDetectorRef, Component, ViewChild, inject } from "@angular/core";
import { FormGroup } from "@angular/forms";
import {
  BelegCreateCommand,
  IBelegCreateCommand,
  BelegeClientProvider,
  ValidationResult,
  InternalServerErrorResult,
} from "src/app/web-api/web-api";
import { WawiApiBelegCreateFormComponent } from "../form/form.component";
import { FormControlBase } from "src/app/common-components/form-controls/form-control-base";
import { finalize } from "rxjs/operators";
import { CstDialogsService } from "src/app/common-components/dialogs/cst-dialogs.service";
import { CstResponsivePopupComponentBase } from "src/app/common-components/resp-popup";

@Component({
    templateUrl: "./dialog.component.html",
    styleUrls: ["./dialog.component.scss"],
    standalone: false
})
export class WawiApiBelegCreateDialogComponent extends CstResponsivePopupComponentBase {
  private _client = inject(BelegeClientProvider);
  private _dlgs = inject(CstDialogsService);
  private _cdr = inject(ChangeDetectorRef);

  @ViewChild(WawiApiBelegCreateFormComponent)
  formComponent: WawiApiBelegCreateFormComponent;

  public loading = false;

  private _tmpInitialValues: IBelegCreateCommand;

  public get form() {
    return this.formComponent ? this.formComponent.form : null;
  }

  public onInitialised() {
    if (this.data) {
      this.PatchValues(this.data);
    }
  }

  public PatchValues(formValues: IBelegCreateCommand) {
    if (!this.form) {
      this._tmpInitialValues = formValues;
      return;
    }
    this.form.patchValue(formValues);
    this._cdr.detectChanges();
  }

  public OnAccept() {
    if (!this.form || !this.form.valid) {
      return;
    }
    const command = new BelegCreateCommand();
    command.init(this.form.value);
    this.loading = true;
    const sub = this._client
      .create(command)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(
        (beleg) => {
          sub.unsubscribe();
          this.close(beleg);
          this._cdr.detectChanges();
        },
        (error) => {
          sub.unsubscribe();
          if (error instanceof ValidationResult) {
            FormControlBase.ApplyValidationResultToForm(this.form, error);
            return;
          } else if (error instanceof InternalServerErrorResult) {
            this._dlgs.DisplayInternalServerError(error).subscribe();
            return;
          }
          console.error(error);
        }
      );
  }

  public OnCancel() {
    this.close();
  }

  public OnFormCreated(event: FormGroup): void {
    if (this._tmpInitialValues) {
      event.patchValue(this._tmpInitialValues);
      this._cdr.detectChanges();
    }
  }
}
